import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

import { theme } from '../styles/theme'
import media from '../styles/media'

const MenuComponent = styled.div`
  position: relative;
  & ul {
    margin: 0;
    width: 100%;
    position: absolute;
    bottom: 25px;
    display: flex;
    justify-content: center;
    ${media.md`
      bottom: 0;
      top: 50px;
    `};
    & li {
      font-size: 14px;
      text-align: center;
      text-transform: uppercase;
      position: relative;
      float: left;
      padding: 10px;
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      ${media.lg`
        font-size: 11px;
      `};
      ${media.md`
        background-color: #1F2122;
        font-size: 14px;
      `};
      &.spacer-15 {
        padding-top: 10px;
        padding-bottom: 10px;
      }

      & a {
        color: ${theme.white};
        padding: 15px;
        display: block;
        line-height: 20px;
        background-color: #1F2122;
        width: 250px;
        ${media.lg`
        width: 200px;
      `};
      ${media.md`
        width: 100%;
      `};
        &:hover {
          text-decoration: none;
        }
      }

      &.active {
        & a {
          color: ${theme.lightBlue};
          font-weight: bold;
        }
      }
    }
  }

  & .navbar-default {
    background-color: #000;
    border: none;
    color: ${theme.white};
    text-align: right;
    position: relative;
    margin: 0;
    display: none;

    h3 {
      display: inline-block;
      padding-top: 13px;
      text-transform: uppercase;
      margin: 0;
      position: absolute;
      top: 0;
      left: 10px;
      cursor: pointer;
    }

    button:focus {
      background: none;
    }
  }

  ${media.md`
    position: relative;
    .navbar{
      border-radius: 0;
    }
    & .navbar-toggle{
      display: block;
    }
    & .navbar-header{
      float: right;
    }
    & ul{
      display: none;
      position: absolute;
      z-index: 5;
      
      &.visible {
        display: block;
      }

      li{
        width: 100%;
        border: none !important;
      }
    }
    & .navbar-default {
      display: block;
    }
  `};
`

export default class Menu extends React.Component {
  state = {
    isVisible: true
  }

  handleToogleMenu = () => {
    this.setState({ isVisible: !this.state.isVisible })
  }

  render() {
    return (
      <MenuComponent>
        <nav className="navbar navbar-default" onClick={this.handleToogleMenu}>
          <div className="container-fluid">
            <div className="navbar-header">
              <h3>Servicios</h3>
              <button type="button" className="navbar-toggle">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
            </div>
          </div>
        </nav>
        <ul id="menu" className={`list-inline ${this.state.isVisible ? '' : 'visible'}`}>
          <li className={this.props.active === 'municipales' ? 'active' : ''}>
            <Link id='CORPIMP_MPAL_PEST' to="/">
              Impuestos Municipales
            </Link>
          </li>
          <li className={`spacer-15 ${this.props.active === 'sri' ? 'active' : ''}`}>
            <Link id='CORPIMP_SRI_PEST' to="/impuestos_sri">Impuestos SRI</Link>
          </li>
          <li className={`spacer-15 ${this.props.active === 'matriculacion' ? 'active' : ''}`}>
            <Link id='CORPIMP_MATRIVEH_PEST' to="/matriculacion">Matriculación Vehicular</Link>
          </li>
          <li className={`last spacer-15 ${this.props.active === 'iess' ? 'active' : ''}`}>
            <Link id='CORPIMP_IESS_PEST' to="/iess">IESS</Link>
          </li>
        </ul>
      </MenuComponent>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu.js